import { useMemo } from "react";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { formatCurrency } from "../../../../../helpers";
import primaryComponents from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import { useStoreListObject } from "../../../../../hooks/useStoreListObject";

export const PriceSummary = ({
  pODetails = {},
  billsForm = {},
  setBillsForm = () => {},
}) => {
  const { storeMap } = useStoreListObject();

  const subtotal = useMemo(() => {
    return billsForm?.items?.reduce((acc, item) => {
      return (acc += item?.cost_price * Number(item?.bill_quantity));
    }, 0);
  }, [billsForm?.items]);

  const total = useMemo(() => {
    let totalValue = subtotal - Number(billsForm?.discount_amount || 0);
    if (billsForm?.vat_rate)
      totalValue += (totalValue * Number(billsForm?.vat_rate)) / 100;

    return totalValue;
  }, [billsForm?.discount_amount, billsForm?.vat_rate, subtotal]);

  const paymentOptions = [
    { id: "cash", name: "Cash" },
    { id: "transfer", name: "Transfer" },
    { id: "card", name: "Card" },
  ];

  return (
    <div
      className="d-flex flex-column flex-md-row w-100"
      style={{ gap: "15px" }}
    >
      <div
        className={`${globalStyles.cardWithBorder} white w-100 pb-0`}
        style={{ gap: "20px" }}
      >
        <h5 className="font-weight-normal">Price Summary</h5>

        <div className="d-flex justify-content-between">
          <p>Subtotal:</p>
          <h6 className="font-weight-normal">
            {formatCurrency({
              value: subtotal,
              currencyCode: pODetails?.store?.currency_code,
            })}
          </h6>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <p>Discount:</p>
          <primaryComponents.AmountField
            placeholder="Enter amount"
            coverClassNames={`${styles.inputField}`}
            value={billsForm?.discount_amount}
            onChange={({ target: { value } }) => {
              setBillsForm((prev) => ({
                ...prev,
                discount_amount: value,
              }));
            }}
            floatError={false}
            currency_code={
              storeMap?.[billsForm?.items?.[0]?.store_id]?.currency_code
            }
          />
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <p>VAT:</p>
          <primaryComponents.PercentageInputField
            name="vat_rate"
            placeholder="Enter %"
            value={billsForm?.vat_rate}
            coverClassNames={`${styles.inputField}`}
            percentBg={"#e4dafc"}
            percentColor={"#7647ee"}
            type="number"
            step={0.01}
            min={0.01}
            onChange={({ target: { value } }) => {
              setBillsForm((prev) => ({
                ...prev,
                vat_rate: value,
              }));
            }}
            floatError={false}
          />
        </div>

        <div className={styles.priceSection}>
          <p>Total</p>
          <h5>
            {formatCurrency({
              value: total,
              currencyCode:
                storeMap?.[billsForm?.items?.[0]?.store_id]?.currency_code,
            })}
          </h5>
        </div>
      </div>
      <div
        className={`${globalStyles.cardWithBorder} white w-100 pb-0`}
        style={{ gap: "20px" }}
      >
        <h5 className="font-weight-normal">Payment Summary</h5>

        <div className="d-flex justify-content-between align-items-center">
          <p>Amount Paid to Supplier:</p>
          <primaryComponents.AmountField
            name="amount_paid_to_supplier"
            placeholder="Enter amount"
            coverClassNames={`${styles.inputField}`}
            value={billsForm?.amount_paid_to_supplier}
            onChange={({ target: { value } }) => {
              setBillsForm((prev) => ({
                ...prev,
                amount_paid_to_supplier: value,
              }));
            }}
            floatError={false}
            currency_code={
              storeMap?.[billsForm?.items?.[0]?.store_id]?.currency_code
            }
          />
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <p>Payment Method:</p>
          <div style={{ width: "200px" }}>
            <primaryComponents.SelectField
              name="payment_method"
              classNames={`${styles.inputField}`}
              options={paymentOptions}
              idKey="id"
              nameKey="name"
              value={
                paymentOptions?.find(
                  (option) => option?.id === billsForm?.payment_method,
                )?.name || "Select method"
              }
              onChange={(value) => {
                setBillsForm((prev) => ({
                  ...prev,
                  payment_method: value,
                }));
              }}
              floatError={false}
              currency_code={pODetails?.store?.currency_code}
            />
          </div>
        </div>

        {/* <div className="d-flex justify-content-between align-items-center">
          <p>Account:</p>
          <div style={{ width: "200px" }}>
            <primaryComponents.SelectField
              name="payment_account"
              classNames={`${styles.inputField}`}
              options={paymentOptions}
              value={"Select account"}
              idKey="id"
              nameKey="name"
              onChange={(value) => {
                setBillsForm((prev) => ({
                  ...prev,
                  account_id: value,
                }));
              }}
              floatError={false}
              currency_code={pODetails?.store?.currency_code}
            />
          </div>
        </div> */}

        <div className={`${styles.priceSection} mt-auto`}>
          <p>Outstanding</p>
          <h5
            className={`${total - Number(billsForm?.amount_paid_to_supplier || 0) > 0 ? "error--text" : "success--text"}`}
          >
            {formatCurrency({
              value: total - Number(billsForm?.amount_paid_to_supplier || 0),
              currencyCode:
                storeMap?.[billsForm?.items?.[0]?.store_id]?.currency_code,
            })}
          </h5>
        </div>
      </div>
    </div>
  );
};
